/* [WEBSITE] "New since your last visit" (Randy S-1025-05 / S-1025-06, 2026-10-25). Counts books first put on the store after the
 * shopper's LAST VISIT ON AN EARLIER DAY; that starting point stays fixed all day, however often they come back. Day boundary =
 * midnight in the shopper's own time zone. Kept only in this browser (localStorage); nothing is sent anywhere.
 * NASince.visit(now) -> the starting point (ms) for today, or null for a first-time visitor. Pure core: NASince.step(state, now). */
(function () {
  var KEY = 'na-visits-v1';
  var dayOf = function (ms) { var d = new Date(ms); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); };
  // S-1025-14 (Randy 2026-10-25): launch day. A device with no visit from an earlier day counts from Sat Oct 24, 2026, 11:00 AM ET (asked: 6 AM,
  // but every book on the real store was published 9-10 AM that day, so 6 AM would mark all 204 as new; 11 AM = after the opening batch), but
  // only through Sun Oct 25 11:59 PM ET; from Monday a first-time visitor sees no marks again (everything is new to them; S-1025-07).
  var LAUNCH = Date.UTC(2026, 9, 24, 15, 0); // Oct 24 11:00 AM EDT
  var LAUNCH_END = Date.UTC(2026, 9, 26, 4, 0); // Oct 26 12:00 AM EDT
  /** One page load (pure): state = { last, start } (ms or null) -> { state, since }. */
  function step(state, now) {
    var last = state && state.last, start = state && state.start;
    if (last && dayOf(last) !== dayOf(now)) start = last; // first visit of a new day: start from the last visit of an earlier day
    var since = start || (now < LAUNCH_END ? LAUNCH : null);
    return { state: { last: now, start: start || null }, since: since };
  }
  function visit(now) {
    var st = null;
    try { st = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    var r = step(st, now || Date.now());
    try { localStorage.setItem(KEY, JSON.stringify(r.state)); } catch (e) {}
    return r.since;
  }
  var api = { step: step, visit: visit, dayOf: dayOf, KEY: KEY, LAUNCH: LAUNCH, LAUNCH_END: LAUNCH_END };
  if (typeof module !== 'undefined') module.exports = api; else window.NASince = api;
})();
